import type { Disease } from "$routes/patient/[:patientId]/_lib/disease-type";

export type InpatientDiagnosis = {
  diseaseSnapshot?: Disease;
  notes?: string;
};

const Diagnosis = (props: { diagnosis: InpatientDiagnosis }) => {
  const {
    diagnosis: { diseaseSnapshot, notes },
  } = props;

  if (!diseaseSnapshot) {
    return <span>{notes}</span>;
  }

  const { displayName } = diseaseSnapshot;

  return <span>{displayName}</span>;
};

export default Diagnosis;
